import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { verveContactActivityService } from "@/services/VerveContactActivityService";
import { showSuccessMessage, showApiError } from "@/lib/toast";

export const useContactActivities = (contactId) => {
  const queryClient = useQueryClient();

  const activitiesQuery = useQuery({
    queryKey: ["contact-activities", contactId],
    queryFn: () => verveContactActivityService.getActivityHistory(contactId),
    enabled: !!contactId
  });

  const addActivityMutation = useMutation({
    mutationFn: (data) => verveContactActivityService.addActivity(contactId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contact-activities", contactId] });
      queryClient.invalidateQueries({ queryKey: ["Verve-contacts"] });
      showSuccessMessage("Activity added");
    },
    onError: (error) => showApiError(error)
  });

  return {
    activities: activitiesQuery.data?.data || activitiesQuery.data || [],
    isLoading: activitiesQuery.isLoading,
    addActivity: addActivityMutation.mutateAsync,
    isAdding: addActivityMutation.isPending
  };
};
